// extracted by mini-css-extract-plugin
export default {"AppLink":"mVYHWKRA","disabled":"AliTnzhY","icon":"mE4ixgad","reverse":"LqYOm8YI","navigation":"CWx_KxPQ","NEXT":"WqwwhjnZ","text":"dBlnkGaV","BACK":"IghVF1zN","PLOT":"YdG8CetE","ROUND":"XuBf1fuO"};
    if(module.hot) {
      // 1717522977827
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  